export default __webpack_public_path__ + "static/dark-pattern-451ab016b7485aceadd4fe56ed78cada.webp";